
import React, { useEffect, useState } from "react";
import { ReptoolModal } from './ReptoolModal.tsx'
import { Button } from "react-bootstrap";
import { useRepToolContext } from "../../RepToolContext.tsx";

import { BasicFetch } from "../../utils/BasicFetch.ts";
const ContactForm = ({
  onSend,
  preselectedQuestion,
  informationText
}: {
  onSend: () => void,
  preselectedQuestion?: string,
  informationText?: string
}) => {
  const questions = [
    "I have a question / comment",
    "I would like to report a bug or make a suggestion",
    "Something Else"
  ]
  const [selectedQuestion, setSelectedQuestion] = useState(preselectedQuestion ? questions[2] : questions[0]);
  const [title, setTitle] = useState(preselectedQuestion || '');
  const [message, setMessage] = useState('');
  const { appendControls } = useRepToolContext();

  const sendMessage = () => {
    if (!message) {
      alert('Please enter a message')
      return;
    }
    BasicFetch({
      url: `${(window as any).serverLocation}/notifications/send_admin`,
      method: 'POST',
      data: { title: title || selectedQuestion, message },
      onSuccess: () => {
        alert('Message Sent');
        onSend();
      }
    })
  }

  useEffect(() => {
    appendControls(<div className='w-100 d-flex'>
      <Button onClick={sendMessage} variant='outline-light' className='mx-auto'>Send</Button>
    </div>, "Contact Modal Menu");
  }, [message, title, selectedQuestion]);


  return (
    <div id="contact_form" className="px-3 d-flex flex-column" >
      {informationText && <p className='text-light'>{informationText}</p>}
      {!preselectedQuestion && <select id="questions" className="bg-dark text-light" value={selectedQuestion} onChange={
        (event) => {
          setSelectedQuestion(event.target.value);
        }
      }>
        {questions.map(question => (
          <option key={question} value={question}>{question}</option>
        ))}
      </select>}
      {
        selectedQuestion === "Something Else" && <input className='mt-3 form-control bg-dark text-light' placeholder="Subject" value={title} onChange={(event) => setTitle(event.target.value)} />
      }

      <textarea className='mt-3 form-control bg-dark text-light' placeholder="Message" rows={4} value={message} onChange={(event) => {
        setMessage(event.target.value)
        console.log(event.target.value)
      }}></textarea>
    </div>
  )
}
export const ContactModal = ({
  onSend,
  closeModal,
  preselectedQuestion,
  informationText
}: {
  closeModal: () => void,
  onSend: () => void,
  preselectedQuestion?: string,
  informationText?: string
}) => {
  return <ReptoolModal id='contact-modal' title="Contact" closeModal={closeModal} body={
    <ContactForm onSend={onSend} preselectedQuestion={preselectedQuestion} informationText={informationText} />
  } />
}